import { APP_BASE_HREF, PlatformLocation } from '@angular/common';
import { ModuleWithProviders, NgModule, Provider } from '@angular/core';

@NgModule({
  imports: []
})
export class ThemesModule {
  static forRoot(themeConfigProvider: Provider): ModuleWithProviders<ThemesModule> {
    return {
      ngModule: ThemesModule,
      providers: [
        themeConfigProvider,
        {
          provide: APP_BASE_HREF,
          useFactory: (platform: PlatformLocation) => { 
            const baseHref =  platform.getBaseHrefFromDOM();
            return baseHref;
          },
          deps: [PlatformLocation]
        }
      ]
    };
  }
}
